/**
 * Shared color ramp for the Display tab's "Market Trends" heat-map fill
 * (Map.ts's polygon fill and MarketTrendsLegend's gradient bar both import
 * from here, so they can never drift out of sync).
 *
 * Cool-to-hot diverging ramp, blue -> yellow -> red (Todd's exact anchor
 * colors: #2c7bb6 / #ffffbf / #d7191c - the classic ColorBrewer RdYlBu
 * triad). 7 stops, linearly interpolated between those 3 anchors (yellow
 * sits exactly in the middle, index 3 of 7), for finer differentiation in
 * the middle of the price range than a bare 3-color ramp would give the
 * polygon fill, which quantizes by array index.
 */
export const MARKET_TRENDS_RAMP = ['#2c7bb6', '#72a7b9', '#b9d3bc', '#ffffbf', '#f2b289', '#e46652', '#d7191c'];
// Distinct neutral, not part of the ramp - areas with too few sales in the
// trailing 12 months to trust a median (see MIN_SAMPLE_SIZE in Map.ts).
export const MARKET_TRENDS_NO_DATA_COLOR = '#d1d5db';
/**
 * Piecewise, not linear min-to-max: the ramp's middle color (yellow) is
 * anchored to `center` (the average of the values actually being colored),
 * not the linear midpoint of the range. Real estate prices are right-
 * skewed - a handful of very expensive areas stretch `max` far out, and a
 * straight linear scale then crushes almost everything else into the
 * bottom sliver of the ramp (all blue, no differentiation) - anchoring the
 * midpoint to where most of the data actually sits fixes that.
 */
export function getMarketTrendsColor(value, min, center, max) {
    if (max <= min)
        return MARKET_TRENDS_RAMP[MARKET_TRENDS_RAMP.length - 1];
    const clamped = Math.max(min, Math.min(max, value));
    let t;
    if (center <= min || center >= max) {
        // Degenerate center (shouldn't normally happen with real data) - fall back to linear.
        t = (clamped - min) / (max - min);
    }
    else if (clamped <= center) {
        t = 0.5 * (clamped - min) / (center - min);
    }
    else {
        t = 0.5 + 0.5 * (clamped - center) / (max - center);
    }
    const index = Math.min(MARKET_TRENDS_RAMP.length - 1, Math.floor(t * MARKET_TRENDS_RAMP.length));
    return MARKET_TRENDS_RAMP[index];
}
//# sourceMappingURL=marketTrendsColors.js.map